import React, {Component} from 'react';
import { connect } from "react-redux";

import Wheel from '../Components/Wheel';
import { updateWheelPrize, updateSpinStatus, wheelSpinning } from '../actions/wheel';

class WheelContainer extends Component{

  constructor(props) {
    super(props);

    this.handleSpinning = this.handleSpinning.bind(this);

    this.state = {
      prize: null
    }
  }

  handleSpinning(spinning) {
    this.props.updateSpinStatus(true);
    this.props.wheelSpinning(spinning);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.prize !== this.props.prize) {
      this.setState({prize: this.props.prize});
    }
  }

  render() {
    const {
      prize
    } = this.state;

    return (
      <Wheel
        prize={prize}
        handleSpinning={this.handleSpinning}
      />
    );
  }
}

const mapStateToProps = state => ({
  prize: state.s_wheel.prize,
});

const mapDispatchToProps = dispatch => ({
  updateWheelPrize: data => {
    dispatch(updateWheelPrize(data));
  },
  updateSpinStatus: data => {
    dispatch(updateSpinStatus(data));
  },
  wheelSpinning: data => {
    dispatch(wheelSpinning(data));
  },
});;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WheelContainer);